import { render, staticRenderFns } from "./EditIconButton.vue?vue&type=template&id=e44ac240&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditIconButton.vue"
export default component.exports